import { Provider, ProviderBranding } from '@/types/tenant';

export const mockProviders: Record<
  string,
  { provider: Provider; branding: ProviderBranding; customScripts: string | null }
> = {
  demo: {
    provider: {
      id: 'demo-provider-id',
      name: 'Demo Provider',
      slug: 'demo',
      domain: 'demo.florentin.dev',
      customDomains: [],
      createdAt: '2024-01-01T00:00:00Z',
      updatedAt: '2024-01-01T00:00:00Z',
    },
    branding: {
      primaryColor: '#3b82f6', // Blue
      secondaryColor: '#1e40af',
      theme: 'light',
      logo: '/logo.svg',
    },
    customScripts: null,
  },
  acme: {
    provider: {
      id: 'acme-provider-id',
      name: 'ACME Corporation',
      slug: 'acme',
      domain: 'acme.florentin.dev',
      customDomains: ['api.acme.com', 'developers.acme.com'],
      createdAt: '2024-01-01T00:00:00Z',
      updatedAt: '2024-01-01T00:00:00Z',
    },
    branding: {
      primaryColor: '#dc2626', // Red
      secondaryColor: '#991b1b',
      theme: 'light',
      logo: '/logo.svg',
    },
    customScripts: null,
  },
  digitalstorm: {
    provider: {
      id: 'digitalstorm-provider-id',
      name: 'Digital Storm',
      slug: 'digitalstorm',
      domain: 'digitalstorm.florentin.dev',
      customDomains: ['api.digitalstorm.io'],
      createdAt: '2024-01-01T00:00:00Z',
      updatedAt: '2024-01-01T00:00:00Z',
    },
    branding: {
      primaryColor: '#8b5cf6', // Purple
      secondaryColor: '#6d28d9',
      theme: 'dark',
      logo: '/logo.svg',
    },
    customScripts: null,
  },
  'tech-solutions': {
    provider: {
      id: '7f680f0b-64d3-455f-8863-cd46e011f114',
      name: 'Tech Solutions',
      slug: 'tech-solutions',
      domain: 'tech-solutions.app',
      customDomains: [],
      createdAt: '2025-08-05T14:27:45Z',
      updatedAt: '2025-08-05T14:27:45Z',
    },
    branding: {
      primaryColor: '#10b981', // Green
      secondaryColor: '#059669',
      theme: 'light',
      logo: '/logo.svg',
    },
    customScripts: null,
  },
};

/**
 * Mock API endpoint for development
 * This simulates the backend provider resolution
 */
export function getMockProviderBySlug(slug: string) {
  return mockProviders[slug] || null;
}

/**
 * Mock API endpoint for domain-based resolution
 * This simulates the backend domain resolution
 */
export function getMockProviderByDomain(domain: string) {
  // Check custom domains
  for (const data of Object.values(mockProviders)) {
    if (data.provider.domain === domain || data.provider.customDomains.includes(domain)) {
      return data;
    }
  }
  
  // Check subdomain
  const subdomain = domain.split('.')[0];
  return getMockProviderBySlug(subdomain);
}
